// extracted by mini-css-extract-plugin
module.exports = {"root":"VideoList_root__3RTMD"};